import { MedicineEditComponent } from '@shared/medicine-edit/medicine-edit.component';
import { MedicineNewComponent } from '@shared/medicine-new/medicine-new.component';
import { Router } from '@angular/router';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { 
    medicineFilterSelect,
    medicineFilterSelected,
    routeMedicines } from '@services/mocks/medicine';
import { ModalService } from '@services/modal.service';
import { skipWhile, take } from 'rxjs';
import { MedicinesService } from '@services/medicines.service';
import { Utils } from '@json/src/app/Utils';
import { Permission, PermissionType } from '@json/src/app/enums/PermissionType';
import { CardsComponent } from './cards/cards.component';
import { LoadingService } from '@services/loading.service';

import { Medicine, MedicineEditEmpty, MedicineForm } from '@interfaces/medicine/medicine.interface';
import { FilterOption, FilterSelect } from '@interfaces/filter.interface';
import { ListsComponent } from './lists/lists.component';
import { CallsService } from '@services/api/calls.service';
import { CustomButtonFilterStatus } from '@enums/custom-button-filter-status';
import { FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { LoggerService } from '@services/logger.service';

@Component({
  selector: 'app-medicines-quantum',
  templateUrl: './medicines-farma.component.html',
  styleUrls: ['./medicines-farma.component.scss'],
})
export class MedicinesFarmaComponent {
    public href: string = '';
    public route: string = routeMedicines;
    public nameButton: string = 'medicineSaveButton';

    medicine?: MedicineEditComponent | MedicineNewComponent;
    public static currentData: Medicine[] = [];
    private sub: any = {};
    nextMed?: number = undefined;
    prevMed?: number = undefined;
    public Utils = Utils;
    public Permission = Permission;
    public PermissionType = PermissionType;

    public medicineFilters = medicineFilterSelect;
    public selectedFilters = medicineFilterSelected;

    private medicines: Medicine[] = [];
    private filteredMedicines: Medicine[] = [];

    public totalElements: number | undefined = undefined;
    public currentElementIndex: number | undefined = undefined;

    public resultsRefreshed: boolean = false;

    public filteredResults: any[] = [];

    cardsRef: CardsComponent;

    public initLoading: boolean = false;

    public paFilter: FormControl = new FormControl();

    constructor(
        private modalService: ModalService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private medicinesService: MedicinesService,
        private loadingService: LoadingService,
        private calls: CallsService,
        private medicineService: MedicinesService,
        private titleService: Title,
        private gaService: GoogleAnalyticsService,
        private logger: LoggerService
    ) { }

    ngOnInit(): void {
        this.medicinesService.clearStoredData();
        this.loadingService.start('Cargando Vademecum...');
        this.initLoading = true;
        this.getMedicines();
        this.titleService.setTitle(`Vademecum`)
        this.gaService.pageView(`${window.location.href}`, `Vademecum`);
        this.logger.logPage('Listado de vademecum');
    }

    getMedicines() {
        this.medicinesService.getMedicines();

        this.medicinesService.medicineList
        .pipe(
            skipWhile((medicines) => medicines === undefined),
            take(1)
        )
        .subscribe((medicines) => {
            if (medicines != undefined) {
                this.medicines = medicines.medicines.map((p) =>
                  this.medicinesService.transformMedicineAPItoApp(p)
                );

                this.filterByConfig(
                    {
                        alert: false,
                        custom: false,
                        filter: "",
                        forceFilterRequest: false,
                        search: "",
                        institution: [],
                        select: [],
                        advancedFilter: this.medicineFilters
                            .map((filter: FilterSelect) => filter.filter)
                            .flat()
                            .map((filter: {id: string, value: string, defaultState?: string}) => {
                                return {
                                    filterId: filter.id,
                                    mode: filter.defaultState || 'include'
                                }
                            })
                    },
                    this.medicines
                )

                if ( this.cardsRef ) {
                    this.cardsRef.currentData = this.filteredMedicines;
                    this.cardsRef instanceof ListsComponent ? (this.cardsRef as ListsComponent).sort() : null;
                    this.cardsRef.loading = false;
                }

                this.loadingService.stop();
                this.initLoading = false;
            } else {
                this.medicinesService.getMedicines();
            } // Hay que llamar si nos llega vacío, si se entra directamente llega vacio
        });
    }

    onOperationBarAction($event: MatButtonToggleChange) {
        switch( $event.value ) {
            case 'first': this.gotToByIndex(0); break;
            case 'last': this.gotToByIndex(this.filteredMedicines.length - 1); break;
            case 'next': this.siguiente(); break;
            case 'prev': this.anterior(); break;
            case 'delete': this.borrar(); break;
            default: this.changeView($event);
        }
    }

    changeView(event: MatButtonToggleChange): void {
        this.modalService.changeView(event, this.route, this.nameButton);
    }

    onActivate(componentRef: any) {
        if (componentRef instanceof MedicineEditComponent || componentRef instanceof MedicineNewComponent) {
            this.resultsRefreshed = false;
            this.medicine = componentRef;

            this.cdr.detectChanges();

            this.sub.medicineList?.unsubscribe();

            if (componentRef.medicineId == null) {
                componentRef.onMedicineId = (id) => {
                    this.updateControlButtons(id, this.filteredMedicines);
                }
            }
            else {
                this.updateControlButtons(componentRef.medicineId, this.filteredMedicines);
            }

            componentRef.onDestroy = () => {
                this.sub.medicineList?.unsubscribe();
            };
            componentRef.onMedicineUpdated = (medicine: MedicineForm, medicineId: string | null) => {
                this.medicinesService.getMedicines().then(() => {
                    /*
                     * Manually update local medicine lists
                     */

                    const updatedMedicine = this.medicinesService.medicineList.getValue()?.medicines.find((m) => m.id == Number(medicineId));
                
                    let medicineIndex: number = this.medicines.findIndex((m: Medicine) => m.id === Number(medicineId));
                    let filteredMedicineIndex: number = this.filteredMedicines.findIndex((m: Medicine) => m.id === Number(medicineId));
                    
                    if ( medicineIndex !== -1 ) {
                        // @ts-ignore
                        const aux = this.medicinesService.transformMedicineAPItoApp(updatedMedicine);

                        this.medicines[medicineIndex] = aux;
                        this.filteredMedicines[filteredMedicineIndex] = aux;
                    }
                });
            }
        } else if (componentRef instanceof CardsComponent) {
            this.cardsRef = componentRef;
            this.cardsRef.currentData = this.filteredMedicines;
            this.cardsRef instanceof ListsComponent ? (this.cardsRef as ListsComponent).sort() : null;
            this.cardsRef.loading = false;
        }
    }

    updateControlButtons(id: string | null, data: Medicine[]) {
        if (id != null) {
            const index = data.findIndex(v => String(v.id) == id);

            this.totalElements = data.length;
            this.currentElementIndex = index + 1;   // Because array starts on 0

            if (index >= 0) {
                this.nextMed = data[index + 1]?.id;
                this.prevMed = data[index - 1]?.id;
                this.cdr.detectChanges();
            }
        }
    }

    anterior(evt?: MatButtonToggleChange) {
        const params = new URLSearchParams(location.search);
        let queryParams: any = {};
        params.forEach((value, key) => {
            queryParams[key] = value;
        });

        // this.router.navigate(["/global-eye/welcome"]).then((r) => {
        //     if (r) {
                this.medicine?.ngOnDestroy();
                this.router.navigate([routeMedicines, 'edit', this.prevMed], {
                    queryParams: queryParams,
                    state: {
                        ignore: false
                    }
                }).then(() => this.medicine?.ngOnInit())
        //     }
        // });
        if (evt != undefined) evt.source.checked = false;
    }

    siguiente(evt?: MatButtonToggleChange) {

        const params = new URLSearchParams(location.search);
        let queryParams: any = {};
        params.forEach((value, key) => {
            queryParams[key] = value;
        });

        // this.router.navigate(["/global-eye/welcome"]).then((r) => {
        //     if (r) {
                this.medicine?.ngOnDestroy();
                this.router.navigate([routeMedicines, 'edit', this.nextMed], {
                    queryParams: queryParams,
                    state: {
                        ignore: false
                    }
                }).then(() => this.medicine?.ngOnInit())
        //     }
        // });
        if (evt != undefined) evt.source.checked = false;
    }

    gotToByIndex(index: number, evt?: MatButtonToggleChange) {
        const params = new URLSearchParams(location.search);
        let queryParams: any = {};
        params.forEach((value, key) => {
            queryParams[key] = value;
        });

        this.medicine?.ngOnDestroy();
        this.router.navigate([routeMedicines, 'edit', this.filteredMedicines[index].id], {
            queryParams: queryParams,
            state: {
                ignore: false
            }
        }).then(() => this.medicine?.ngOnInit())

        if (evt != undefined) evt.source.checked = false;
    }

    borrar(evt?: MatButtonToggleChange) {
        if (evt != undefined) evt.source.checked = false;
        this.modalService.openModalCallback(() => {
            this.loadingService.start("Eliminando...");
            this.calls.deleteMedicine(Number(this.medicine?.medicineId)).subscribe({
                next: (data) => {
                    this.loadingService.stop()
                    this.siguiente(undefined);
                },
                complete: () => this.loadingService.stop()
            });
        }, "¿Está seguro de que desea eliminar la medicina?", "Eliminar medicina", false)
    }

    showArrows() {
        return this.router.url.includes("/medicines/edit");
    }
    onListPage() {
        return this.router.url.includes("/medicines/cards") || this.router.url.includes("/medicines/list");
    }
    onEditPage() {
        return this.router.url.includes("/medicines/edit");
    }

    onFilterResultSelected($event: any) {
        const params = new URLSearchParams(location.search);
        let queryParams: any = {};
        params.forEach((value, key) => {
            queryParams[key] = value;
        });

        this.medicine?.ngOnDestroy();
        this.router.navigate([`${this.route}/edit/${$event}`], {
            queryParams: queryParams,
            state: {
                ignore: false
            }
        }).then(() => this.medicine?.ngOnInit())
    }

    filter($event: any) {
        if ( $event.filter.trim().length > 0 || $event.forceFilterRequest ) {
            this.sub.filter?.unsubscribe();

            // Request patients by filter
            this.medicinesService.getMedicinesByFilter($event.filter);

            this.sub.filter = this.medicinesService.medicineList
            .subscribe((p) => {
                /*
                 * Patients by filter query
                 */
                if(p) {
                    this.medicines = p.medicines.map((item) => this.medicinesService.transformMedicineAPItoApp(item));
                    this.filterByConfig($event, this.medicines);
                }
            })
        } else {
            this.filterByConfig($event, this.medicines);
        }
    }

    filterByConfig(filters: any, medicines: Medicine[]) {

        /*
         * Filter patients by selected filters
         */
        const noPrescriptionFilter = filters.custom;
        const obsoleteFilter = filters.custom2;
        const fgpFilter = filters.custom3;

        let cobertMedicines = medicines.filter(m => this.medicinesService.isCobert(m.flag));
        let payMedMedicines = medicines.filter(m => !this.medicinesService.isCobert(m.flag));
        let alzheimerMedicines = medicines.filter(m => this.medicinesService.isAlzheimer(m.flag));
        let emblistableMedicines = medicines.filter(m => !this.medicinesService.isNoBlister(m.flag));
        let noEmblistableMedicines = medicines.filter(m => this.medicinesService.isNoBlister(m.flag));
        let unitdoseMedicines = medicines.filter(m => this.medicinesService.isUnidosis(m.flag));
        let raMedicines = medicines.filter(m => this.medicinesService.isRA(m.flag));
        let mecMedicines = medicines.filter(m => this.medicinesService.isMEC(m.flag));
        let roMedicines = medicines.filter(m => this.medicinesService.isR0(m.flag));
        let hospitalUseMedicines = medicines.filter(m => this.medicinesService.isHospitalUse(m.flag));
        let noInventaryMedicines = medicines.filter(m => this.medicinesService.isOutStock(m.flag));
        let diaperMedicines = medicines.filter(m => this.medicinesService.isDiaper(m.flag));
        let antidepressantMedicines = medicines.filter(m => this.medicinesService.isAntidepressant(m.flag));
        let ansioliticMedicines = medicines.filter(m => this.medicinesService.isAnsiolitic(m.flag));
        let antipsychoticMedicines = medicines.filter(m => this.medicinesService.isAntipsychotic(m.flag));
        let anticonvilsantMedicines = medicines.filter(m => this.medicinesService.isAnticonvulsant(m.flag));
        let antibioticMedicines = medicines.filter(m => this.medicinesService.isAntibiotic(m.flag));
        let anticoagulantMedicines = medicines.filter(m => this.medicinesService.isAnticoagulant(m.flag));
        let aineMedicines = medicines.filter(m => this.medicinesService.isAINE(m.flag));
        let ibpMedicines = medicines.filter(m => this.medicinesService.isIBP(m.flag));
        let hipnoticoMedicines = medicines.filter(m => this.medicinesService.isHipnotico(m.flag));
        let antihipertensivoMedicines = medicines.filter(m => this.medicinesService.isAntihipertensivo(m.flag));
        let parkinsonMedicines = medicines.filter(m => this.medicinesService.isParkinson(m.flag));
        let vitaminasHierroMedicines = medicines.filter(m => this.medicinesService.isVitaminasHierro(m.flag));
        let diabetesMedicines = medicines.filter(m => this.medicinesService.isDiabetes(m.flag));
        let opioidMedicines = medicines.filter(m => this.medicinesService.isOpioid(m.flag));
        let dangerGroupMedicines1 = medicines.filter(m => m.dangerGroup === 1);
        let dangerGroupMedicines2 = medicines.filter(m => m.dangerGroup === 2);
        let dangerGroupMedicines3 = medicines.filter(m => m.dangerGroup === 3);
        let otherMedicines = medicines.filter(m => 
            !cobertMedicines.includes(m) && 
            !payMedMedicines.includes(m) && 
            !alzheimerMedicines.includes(m) && 
            !noEmblistableMedicines.includes(m) && 
            !unitdoseMedicines.includes(m) && 
            !raMedicines.includes(m) && 
            !mecMedicines.includes(m) && 
            !roMedicines.includes(m) && 
            !hospitalUseMedicines.includes(m) && 
            !noInventaryMedicines.includes(m) && 
            !diaperMedicines.includes(m) && 
            !antidepressantMedicines.includes(m) && 
            !ansioliticMedicines.includes(m) && 
            !antipsychoticMedicines.includes(m) && 
            !anticonvilsantMedicines.includes(m) && 
            !antibioticMedicines.includes(m) && 
            !anticoagulantMedicines.includes(m) && 
            !aineMedicines.includes(m) && 
            !ibpMedicines.includes(m) && 
            !hipnoticoMedicines.includes(m) && 
            !antihipertensivoMedicines.includes(m) && 
            !parkinsonMedicines.includes(m) && 
            !vitaminasHierroMedicines.includes(m) && 
            !diabetesMedicines.includes(m) && 
            !opioidMedicines.includes(m) && 
            !dangerGroupMedicines1.includes(m) && 
            !dangerGroupMedicines2.includes(m) && 
            !dangerGroupMedicines3.includes(m)
        );

        this.filteredMedicines = [];

        filters.advancedFilter?.forEach((filter: {filterId: string, mode: 'exclude' | 'include' | 'exclusive'}) => {
            switch (filter.filterId) {
                case 'cobert':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...cobertMedicines])];
                    } else {
                        this.filteredMedicines = cobertMedicines;
                    }
                    break;
                case 'no-cobert':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...payMedMedicines])];
                    } else {
                        this.filteredMedicines = payMedMedicines;
                    }
                    break;
                case 'alzheimer':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...alzheimerMedicines])];
                    } else {
                        this.filteredMedicines = alzheimerMedicines;
                    }
                    break;
                case 'emblistable':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...emblistableMedicines])];
                    } else {
                        this.filteredMedicines = emblistableMedicines;
                    }
                    break;
                case 'no-emblistable':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...noEmblistableMedicines])];
                    } else {
                        this.filteredMedicines = noEmblistableMedicines;
                    }
                    break;
                case 'unitdose':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...unitdoseMedicines])];
                    } else {
                        this.filteredMedicines = unitdoseMedicines;
                    }
                    break;
                case 'ra':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...raMedicines])];
                    } else {
                        this.filteredMedicines = raMedicines;
                    }
                    break;
                case 'mec':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...mecMedicines])];
                    } else {
                        this.filteredMedicines = mecMedicines;
                    }
                    break;
                case 'ro':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...roMedicines])];
                    } else {
                        this.filteredMedicines = roMedicines;
                    }
                    break;
                case 'hospital-use':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...hospitalUseMedicines])];
                    } else {
                        this.filteredMedicines = hospitalUseMedicines;
                    }
                    break;
                case 'no-inventary':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...noInventaryMedicines])];
                    } else {
                        this.filteredMedicines = noInventaryMedicines;
                    }
                    break;
                case 'diaper':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...diaperMedicines])];
                    } else {
                        this.filteredMedicines = diaperMedicines;
                    }
                    break;
                case 'nervadp':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...antidepressantMedicines])];
                    } else {
                        this.filteredMedicines = antidepressantMedicines;
                    }
                    break;
                case 'nervans':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...ansioliticMedicines])];
                    } else {
                        this.filteredMedicines = ansioliticMedicines;
                    }
                    break;
                case 'nervaps':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...antipsychoticMedicines])];
                    } else {
                        this.filteredMedicines = antipsychoticMedicines;
                    }
                    break;
                case 'nerveutatc':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...anticonvilsantMedicines])];
                    } else {
                        this.filteredMedicines = anticonvilsantMedicines;
                    }
                    break;
                case 'antibio':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...antibioticMedicines])];
                    } else {
                        this.filteredMedicines = antibioticMedicines;
                    }
                    break;
                case 'anticoag':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...anticoagulantMedicines])];
                    } else {
                        this.filteredMedicines = anticoagulantMedicines;
                    }
                    break;
                case 'aine':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...aineMedicines])];
                    } else {
                        this.filteredMedicines = aineMedicines;
                    }
                    break;
                case 'ibp':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...ibpMedicines])];
                    } else {
                        this.filteredMedicines = ibpMedicines;
                    }
                    break;
                case 'hipnotico':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...hipnoticoMedicines])];
                    } else {
                        this.filteredMedicines = hipnoticoMedicines;
                    }
                    break;
                case 'antihipertensivo':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...antihipertensivoMedicines])];
                    } else {
                        this.filteredMedicines = antihipertensivoMedicines;
                    }
                    break;
                case 'parkinson':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...parkinsonMedicines])];
                    } else {
                        this.filteredMedicines = parkinsonMedicines;
                    }
                    break;
                case 'vitaminas-hierro':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...vitaminasHierroMedicines])];
                    } else {
                        this.filteredMedicines = vitaminasHierroMedicines;
                    }
                    break;
                case 'diabetes':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...diabetesMedicines])];
                    } else {
                        this.filteredMedicines = diabetesMedicines;
                    }
                    break;
                case 'opioid':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...opioidMedicines])];
                    } else {
                        this.filteredMedicines = opioidMedicines;
                    }
                    break;
                case 'others':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...otherMedicines])];
                    } else {
                        this.filteredMedicines = otherMedicines;
                    }
                    break;
                case 'dangerous-group-1':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...dangerGroupMedicines1])];
                    } else {
                        this.filteredMedicines = dangerGroupMedicines1;
                    }
                    break;
                case 'dangerous-group-2':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...dangerGroupMedicines2])];
                    } else {
                        this.filteredMedicines = dangerGroupMedicines2;
                    }
                    break;
                case 'dangerous-group-3':
                    if ( filter.mode === 'exclude' ) {
                        // Do nothing
                    } else if ( filter.mode === 'include' ) {
                        this.filteredMedicines = [...new Set([...this.filteredMedicines, ...dangerGroupMedicines3])];
                    } else {
                        this.filteredMedicines = dangerGroupMedicines3;
                    }
                    break;
            }
        });

        if ( noPrescriptionFilter === CustomButtonFilterStatus.Include ) {
            this.filteredMedicines = [...new Set([...this.filteredMedicines, ...this.filteredMedicines.filter(m => this.medicinesService.isNoPrescribe(m.flag))])];
        } else if ( noPrescriptionFilter === CustomButtonFilterStatus.ShowOnly ) {
            this.filteredMedicines = this.filteredMedicines.filter(m => this.medicinesService.isNoPrescribe(m.flag));
        } else {
            this.filteredMedicines = this.filteredMedicines.filter(m => !this.medicinesService.isNoPrescribe(m.flag));
        }

        if ( obsoleteFilter === CustomButtonFilterStatus.Include ) {
            this.filteredMedicines = [...new Set([...this.filteredMedicines, ...this.filteredMedicines.filter(m => this.medicinesService.isObsolete(m.flag))])];
        } else if ( obsoleteFilter === CustomButtonFilterStatus.ShowOnly ) {
            this.filteredMedicines = this.filteredMedicines.filter(m => this.medicinesService.isObsolete(m.flag));
        } else {
            this.filteredMedicines = this.filteredMedicines.filter(m => !this.medicinesService.isObsolete(m.flag));
        }

        if ( fgpFilter === CustomButtonFilterStatus.Include ) {
            this.filteredMedicines = [...new Set([...this.filteredMedicines, ...this.filteredMedicines.filter(m => m.FGP)])];
        } else if ( fgpFilter === CustomButtonFilterStatus.ShowOnly ) {
            this.filteredMedicines = this.filteredMedicines.filter(m => m.FGP);
        } else {
            this.filteredMedicines = this.filteredMedicines.filter(m => !m.FGP)
        }

        // Filter by name
        this.filteredMedicines = this.filteredMedicines
        .map((medicine: Medicine) => {
            // Disable filter by PA
            // @ts-ignore
            delete medicine.PA_LIST
            return medicine;
        })
        .filter((medicine: Medicine) =>
            (filters.alert ? this.medicinesService.hasAlert(medicine.flag) : true) &&
            (filters.search.trim().length == 0 ? true : Object.values(medicine).some((val) =>
                filters.search.trim().length > 0 &&
                filters.search.split(' ').every((search: string) => {
                    return val
                        ?.toString()
                        .toLowerCase()
                        .replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u')
                        .includes(search.toLowerCase().replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u'))
                })
            ))
        )

        // Filter by active ingredients
        if ( filters.otherFilters?.pa?.trim().length > 0 ) {
            this.filteredMedicines = this.filteredMedicines
            .map((medicine: Medicine) => {
                // Enable filter by PA by creating an string of PA names
                // @ts-ignore
                medicine.PA_LIST = medicine.PA.map((pa) => pa.Nombre).join(' ');
                return medicine;
            })
            .filter((medicine: Medicine) =>
                (filters.otherFilters.pa.trim().length == 0 ? true : Object.values(medicine).some((val) =>
                    filters.otherFilters.pa.trim().length > 0 &&
                    filters.otherFilters.pa.split(' ').every((search: string) => {
                        return val
                            ?.toString()
                            .toLowerCase()
                            .replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u')
                            .includes(search.toLowerCase().replace('á', 'a').replace('é', 'e').replace('í', 'i').replace('ó', 'o').replace('ú', 'u'))
                    })
                ))
            )
        }


        // Sort filtered result
        this.filteredMedicines = this.filteredMedicines.sort((a: Medicine, b: Medicine) => {
            if (a.name.trim().toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") < b.name.trim().toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) return -1
            if (a.name.trim().toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") > b.name.trim().toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) return 1
            return 0;
        });

        // Update cards medicines
        if ( this.cardsRef ) {
            this.cardsRef.currentData = this.filteredMedicines;
            this.cardsRef instanceof ListsComponent ? (this.cardsRef as ListsComponent).sort() : null;
            this.cardsRef.paginator.firstPage();
        }

        this.filteredResults = this.filteredMedicines.map((medicine: Medicine) => {
            return { id: medicine.id, label: medicine.name }
        });

        this.resultsRefreshed = false;
        this.cdr.detectChanges();
        this.resultsRefreshed = true;
        this.cdr.detectChanges();
    }
}
